import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

const customTheme = {
    primary  : '#0052CC',
    secondary: '#424242',
    accent   : '#82b1ff',
    error    : '#ff5252',
    info     : '#2196f3',
    success  : '#4caf50',
    warning  : '#ffc107',
    headerBg : '#0052CC',
    white    : '#fff',
    grey     : '#919191'
}

Vue.use(Vuetify, {
    iconfont: 'md',
    theme   : customTheme
})
